// eslint-disable-next-line max-classes-per-file
import type { PromotionProductTypeEnum } from "./getPromotionListInterface";

export interface RequestCouponListInterface {
  type: PromotionProductTypeEnum;
}
export interface CouponProductType {
  key: string;
  name: string;
  iconInactive: string;
  iconActive: string;
}

export interface CouponList {
  id: number;
  couponItemId: number;
  promotionSlug: string;
  promotionId: number;
  description: string;
  subDescription?: string;
  couponAmountType: string;
  couponAmount: string;
  currency: string;
  couponCode: string;
  conditionValue: string;
  createdAt: string;
  updatedAt: string;
  isB2B2C: boolean;
  couponProductType: CouponProductType[];
  isOutOfStock: boolean;
  travelPeriod: any;
  isRequireLogin: boolean;
  title: string;
  isPromotionPayment: boolean;
  icon: string[];
}

export interface Type {
  name: string;
  url: string;
}

export interface Category {
  id: string;
  name: string;
}
export interface CouponData {
  couponList: CouponList[];
  type: Type[];
  category: Category[];
  total: number;
}

export interface TravelPeriod {
  type: string;

  start: string;

  end: string;
}

export class CouponListClass {
  id: number;

  couponItemId: number;

  promotionId: number;

  promotionSlug: string;

  description: string;

  subDescription?: string;

  couponAmountType: string;

  couponAmount: string;

  currency: string;

  couponCode: string;

  conditionValue: string;

  createdAt: string;

  updatedAt: string;

  isB2B2C: boolean;

  couponProductType: CouponProductType[];

  isOutOfStock: boolean;

  travelPeriod: TravelPeriod;

  isRequireLogin: boolean;

  title: string;

  isPromotionPayment: boolean;

  icon: string[];

  constructor(data: CouponList) {
    this.id = data.id || 0;
    this.couponItemId = data.couponItemId || 0;
    this.promotionSlug = data.promotionSlug || "";
    this.promotionId = data.promotionId || 0;
    this.description = data.description || "";
    this.subDescription = data.subDescription || "";
    this.couponAmountType = data.couponAmountType || "";
    this.couponAmount = data.couponAmount || "";
    this.currency = data.currency || "";
    this.couponCode = data.couponCode || "";
    this.conditionValue = data.conditionValue || "";
    this.createdAt = data.createdAt || "";
    this.updatedAt = data.updatedAt || "";
    this.isB2B2C = data.isB2B2C || false;
    this.couponProductType = data.couponProductType || [];
    this.isOutOfStock = data.isOutOfStock || false;
    this.travelPeriod = data.travelPeriod || null;
    this.isRequireLogin = data.isRequireLogin || false;
    this.title = data.title || "";
    this.isPromotionPayment = data.isPromotionPayment || false;
    this.icon = data.icon || null;
  }
}

export class CouponDataClass {
  couponList: CouponList[];

  type: Type[];

  category: Category[];

  total: number;

  constructor(data: CouponData) {
    this.couponList = (data.couponList || []).map(
      (coupon) => new CouponListClass(coupon),
    );
    this.type = data.type || [];
    this.category = data.category || [];
    this.total = data.total || 0;
  }
}

export class ResponseCouponList {
  version: string;

  status: boolean;

  code: string;

  message: string;

  data: CouponData;

  constructor(data: any) {
    this.version = data.version || "";
    this.status = data.status || false;
    this.code = data.code || "";
    this.message = data.message || "";
    this.data = new CouponDataClass(data.data || {});
  }
}
